/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DetalhesRequisicaoAliases {
  ACCORDION_ANEXOS = 'accordion-anexos',
  ACCORDION_CID = 'accordion-cid',
  ACCORDION_GLOSAS = 'accordion-glosas',
  ACCORDION_PROC_MAT = 'accordion-proc-mat',
  ACTION_IMPRIMIR = 'action-imprimir',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_ANEXOS = 'deck-anexos',
  DECK_PROCEDIMENTOS_MATERIAIS = 'deck-procedimentos-materiais',
  FETCH_ANEXOS = 'fetch-anexos',
  FETCH_CID = 'fetch-cid',
  FETCH_GLOSAS_OCORRENCIAS = 'fetch-glosas-ocorrencias',
  FETCH_PROCEDIMENTOS_MATERIAIS = 'fetch-procedimentos-materiais',
  FETCH_REQUISICAO = 'fetch-requisicao',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_9 = 'field-9',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_12 = 'field-12',
  FIELD_13 = 'field-13',
  FIELD_14 = 'field-14',
  FIELD_15 = 'field-15',
  FIELD_16 = 'field-16',
  FIELD_17 = 'field-17',
  FIELD_18 = 'field-18',
  FIELD_19 = 'field-19',
  FIELD_20 = 'field-20',
  FIELD_21 = 'field-21',
  FIELD_22 = 'field-22',
  FIELD_23 = 'field-23',
  FIELD_24 = 'field-24',
  FIELD_25 = 'field-25',
  FIELD_26 = 'field-26',
  FIELD_ODONTO = 'field-odonto',
  FORM_0 = 'form-0',
  FRAGMENT_0 = 'fragment-0',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPSE = 'hpms-custom-card-content-collapse',
  HPMS_CUSTOM_CARD_PROCEDIMENTO_MATERIAL = 'hpms-custom-card-procedimento-material',
  HPMS_DYNAMIC_ACTION = 'hpms-dynamic-action',
  HPMS_DYNAMIC_STATUS = 'hpms-dynamic-status',
  IMAGE_1 = 'image-1',
  LAYOUT_0 = 'layout-0',
  LAYOUT_DETALHES_REQUISICAO = 'layout-detalhes-requisicao',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_AVATAR = 'mapper-avatar',
  PANEL_0 = 'panel-0',
  PANEL_10 = 'panel-10',
  PANEL_ANEXOS = 'panel-anexos',
  PANEL_CID = 'panel-cid',
  PANEL_GLOSAS_OCORRENCIAS = 'panel-glosas-ocorrencias',
  PANEL_LOADER = 'panel-loader',
  PANEL_PROCEDIMENTOS_MATERIAIS = 'panel-procedimentos-materiais',
  PANEL_REQUISICAO = 'panel-requisicao',
  REPEATER_0 = 'repeater-0',
  REPEATER_CID = 'repeater-cid',
  TAB_ANEXOS_TISS = 'tab-anexos-tiss',
  TAB_CONTROL_REQUISICAO = 'tab-control-requisicao',
  TAB_DADOS_REQUISICAO = 'tab-dados-requisicao',
  TEXT = 'text',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_11 = 'text-11',
  TEXT_12 = 'text-12',
  TEXT_13 = 'text-13',
  TEXT_14 = 'text-14',
  TEXT_15 = 'text-15',
  TEXT_16 = 'text-16',
  TEXT_18 = 'text-18',
  TEXT_19 = 'text-19',
  TEXT_20 = 'text-20',
  TEXT_22 = 'text-22',
  TEXT_23 = 'text-23',
  TEXT_25 = 'text-25',
  TEXT_26 = 'text-26',
  TEXT_27 = 'text-27',
  TEXT_29 = 'text-29',
  TEXT_CID_TITLE = 'text-cid-title',
  TEXT_ODONTO = 'text-odonto',
  TEXT_TITLE_ANEXOS = 'text-title-anexos',
  TEXT_TITLE_GLOSAS = 'text-title-glosas',
  TEXT_TITLE_PROC_MAT = 'text-title-proc-mat',
}
export { DetalhesRequisicaoAliases };
